import { EMPTY_VALUE_PLACEHOLDER } from "../models/common/data";
import { Maybe } from "../models/common/generic-types";
import { isEmptyValue } from "./is-empty-value";

/**
 * @description creates a formatted currency value
 * @param val the currency value
 * @param maximumFractionDigits
 */

export default (val: Maybe<string | number> | undefined, maximumFractionDigits?: number | null, minimumFractionDigits?: number | null) => {
	if (isEmptyValue(val) || isNaN(+(val as any))) {
		return EMPTY_VALUE_PLACEHOLDER;
	}

	return `${(+(val as any)).toLocaleString("en", {
		maximumFractionDigits: maximumFractionDigits || 0,
		minimumFractionDigits: minimumFractionDigits || 0,
	})}`;
};
